"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Store = _interopRequireDefault(require("./private/Store"));

var _Dispatcher = _interopRequireDefault(require("./private/Dispatcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(isProduction, log) {
  var Store = (0, _Store["default"])(isProduction, log);
  var Dispatch = (0, _Dispatcher["default"])(isProduction, log);
  return {
    nextState: Store.nextState,
    mergeState: Store.mergeState,
    getState: Store.getState,
    nextAction: Dispatch.nextAction,
    getAction: Dispatch.getAction,
    getStateUndefined: Store.getStateUndefined
  };
};

exports["default"] = _default;
//# sourceMappingURL=Dispatch.js.map